import React, { useEffect } from 'react';
import { BrowserRouter, Route, useHistory } from 'react-router-dom';
import { PrivateRoute } from './Private.routes';
import Login from '../Pages/Login';
import HomeRoute from './Home.routes';
import { fromUnixTime, isAfter } from 'date-fns';
import { useAblContext } from '../Hooks/useAblContext';

function UserRoute() {
  const history = useHistory();
  const abl = useAblContext();
  useEffect(() => {

    if(abl.token.length) {
      const { exp, role } = JSON.parse(atob(abl.token.split('.')[1]));
      const expireDate = fromUnixTime(exp);

      if(isAfter(new Date(), expireDate )){
        abl.saveRoles("");
        abl.saveAuthenticated(false);
        return history.replace('/login');
      }
      abl.saveRoles(role[0]);
      abl.saveAuthenticated(true);
      return history.replace('/home');
    }
  }, [])

  return(
      <BrowserRouter>
        <Route path="/login" exact component={Login}/>
        <PrivateRoute path="/home" component={HomeRoute} />
      </BrowserRouter>
  )
}

export default UserRoute;
